<template>
    <div style="padding: 20px">
        <el-drawer :visible.sync="isShow" title="绑定酒店" size="800px" hide-footer @close="$emit('close')">
            <div style="">
                <el-button type="primary" size="small" @click="handleAddHotel">绑定酒店</el-button>
            </div>

            <el-table border style="width:100%;margin-top:10px;" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" :data="hotelList" size="small">
                <el-table-column type="index" label="#" fixed="left" width="60" align="center"></el-table-column>
                <el-table-column prop="name" label="酒店名称" align="center"></el-table-column>
                <el-table-column :prop="tableProp.nickname || 'nickname'" label="联系人" align="center"></el-table-column>
                <el-table-column label="操作" fixed="right" width='200'>
                    <template slot-scope="{row}">
                        <el-button type="danger" size="mini" @click="handleUnBindHotel(row)">解绑</el-button>
                        <el-button type="primary" v-if="showCode" size="mini" @click="handleCheckCode(row)">生成二维码</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div style="text-align: right; padding: 10px 20px 0 0;">
                <el-pagination @size-change="handleChangesize" @current-change="handleChangePage" :current-page="searchForm.pageNumber" :page-sizes="[10, 20,50]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </el-drawer>

        <!-- 选择酒店的弹窗 -->
        <el-dialog width="680px" title="请选择酒店" :visible.sync="isSelect" @click="isSelect=false" append-to-body destroy-on-close :close-on-press-escape="false" :cel-dialoglose-on-click-modal="false">
            <el-form :inline="true" :model="selectForm" ref="selectForm" @keydown.enter.native="handleSearchHotel">
                <el-form-item label="酒店名称" prop="name">
                    <el-input v-model="selectForm.name" placeholder="请输入酒店名称" size="small" style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearchHotel" size="small">搜索</el-button>
                    <el-button @click="resetForm('selectForm')" size="small">重置</el-button>
                </el-form-item>
            </el-form>

            <el-table ref="multipleTable" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" :data="selectHotelList" style="width: 100%" border size="mini" row-key="hotelId" @select="handleselectionsChange"
                @select-all="handleSelectAll">
                <el-table-column type="selection" label="#" width="60" align="center"></el-table-column>
                <el-table-column prop="name" label="酒店名称"></el-table-column>
                <el-table-column prop="contact" label="联系人" align="center"></el-table-column>
            </el-table>

            <div style="text-align:right;margin-top:10px;">
                <el-pagination background layout="total, prev, pager, next, jumper" :total="hotelTotal" @current-change="handleChangeSelectPage" :current-page="selectForm.pageNumber" :page-size="selectForm.pageSize"></el-pagination>
            </div>

            <div slot="footer" class="dialog-footer" style="text-align: right;padding-top: 20px">
                <el-button size="small" @click="handleCancel">取 消</el-button>
                <el-button size="small" :loading="submitLoading" type="primary" @click="handleSubmit">确认</el-button>
            </div>
        </el-dialog>
        <!-- 二维码 -->
        <el-dialog :visible.sync="isView" title="图片" width="500px" append-to-body destroy-on-close :close-on-press-escape="false" :close-on-click-modal="false">
            <div id="capture" class="view_hb">
                <div style="display: flex;align-items: center;justify-content: center;">
                    <img :src="imgUrl" alt="" style="max-height: 150px;max-width: 150px;border-radius: 50%;" />
                </div>
            </div>
            <div slot="footer">
                <el-button @click="saveFile" :loading="downLoading">保存二维码</el-button>
                <el-button size="small" type="primary" @click="isView = false">关闭</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
import { removeArrRepeat } from "@/utils/util";
export default {
    props: {
        httpConfig: {
            type: Object,
            default: () => {
                return {}
            }
        },
        showCode: {
            type: Boolean,
            default: false
        },
        propsData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        tableProp: {
            type: Object,
            default: () => {
                return {
                    nickname: 'nickname'
                }
            }
        },
        isBind: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isShow: false,
            isView: false,
            downLoading: false,
            imgUrl: '',
            loading: false,
            searchForm: {
                pageNumber: 1,
                pageSize: 10
            },
            selectForm: {
                name: '',
                pageNumber: 1,
                pageSize: 10
            },
            total: 0,
            hotelList: [],
            hotelTotal: 0,
            isSelect: false,
            submitLoading: false,
            selectHotelList: [],
            selections: [],
        }
    },
    watch: {
        isBind(newVal) {
            this.isShow = !!newVal;
            if (newVal) {
                this.searchForm = Object.assign(this.searchForm, this.propsData)
                this.getHotelList();
            }
        }
    },
    methods: {
        saveFile() {
            this.downLoading = true;
            let a = document.createElement('a');      //创建一个a标签用来跳转
            a.href = this.imgUrl;                             // a标签 href  赋值 链接  
            a.download = '二维码.jpeg';                  //设置下载文件的文件名和文件格式， 这里一定要加上格式，不然下载的文件一直是txt格式的
            document.body.appendChild(a);             //将标签DOM，放置页面
            a.click();                              
            window.URL.revokeObjectURL(this.imgUrl);     //释放 url 对象内存
            document.body.removeChild(a);
            this.downLoading = false
        },
        handleCheckCode(row) {
            this.exportRequest(`/api/hotel/getMiniProgramCode?hotelId=${row.hotelId}&path=/pages/index/index&username=${this.propsData.username}`)
            .then(res => {
                let reader = new FileReader();
                reader.readAsText(res.data, "utf-8")
                reader.onload = e => {
                    let data = e.target.result;
                    if (!data.includes("msg")) {
                        let blob = new Blob([res.data], { type: 'image/png' });
                        // let url = window.URL.createObjectURL(blob);

                        let reader = new FileReader();
                        reader.readAsDataURL(blob);

                        reader.onload = e => {
                            this.imgUrl = e.target.result;
                            this.isView = true
                        }
                    } else {
                    }

                }
            })
        },
        handleSubmit() {
            if (!this.selections.length) {
                this.$message.warning("请选择需要绑定的酒店");
                return;
            }

            this.submitLoading = true;
            this.handleSubmitBindHotel();
        },
        handleSubmitBindHotel() {
            let postData = Object.assign({}, this.propsData);
            postData.hotelIdList = this.selections.map(item => {
                return item.hotelId;
            })

            this.postRequest(this.httpConfig.bindHotel, postData)
                .then(res => {
                    let data = res.data;

                    this.submitLoading = false;
                    if (data.code == 200) {

                        this.$message.success(data.msg);
                        this.isSelect = false;
                        this.searchForm.pageNumber = 1;
                        this.getHotelList();
                    } else {
                        this.$message.warning(data.msg);
                        this.isSelect = false;
                    }
                }).catch(err => {
                    this.submitLoading = false;
                })
        },
        handleCancel() {//选择的绑定酒店
            this.isSelect = false;
            this.getHotelList();
        },
        handleAddHotel() {
            this.isSelect = true;
            this.selections = [];
            this.getAllHotelList();
        },
        handleUnBindHotel(row) {
            this.$confirm('是否解绑该酒店?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.handleUnBindHotelApi([row.hotelId]);
            }).catch(() => {

            });
        },
        handleselectionsChange(val, row) {
            let isTrue = false;
            this.selections.forEach((item, index) => {
                if (item.hotelId == row.hotelId) {
                    this.selections.splice(index, 1);
                    isTrue = true;
                }
            });
            if (!isTrue) {
                this.selections.push(row);
            }
        },
        handleSelectAll(val) {
            var _this = this;

            if (!_this.selections.length) {
                [..._this.selections] = val;
            } else {
                if (val.length) {
                    _this.selections = removeArrRepeat(_this.selections.concat(val));
                } else {
                    _this.selectHotelList.forEach((item, index) => {
                        _this.selections.forEach((val, key) => {
                            if (val.hotelId == item.hotelId) {
                                _this.selections.splice(key, 1);
                            }
                        });
                    });
                }
            };
        },
        // handleBatchUnBindHotel(){
        //     if(this.selections.length<=0){
        //         this.$message.error('请先选择要解绑的酒店');
        //         return;
        //     }
        //     this.$Modal.confirm({
        //         title: '提示',
        //         content: `您确定要解绑该条数据?`,
        //         onOk: () => {
        //             let postData = Object.assign({}, this.propsData);
        //             postData.hotelIds = this.selections.map(item => item.hotelId);
        //             this.handleUnBindHotelApi(postData);
        //         }
        //     });
        // },
        handleUnBindHotelApi(data) {
            let postData = Object.assign({}, this.propsData);
            postData.hotelIdList = data;
            this.postRequest(this.httpConfig.unbindHotel, postData)
                .then(res => {
                    let data = res.data;

                    if (data.code == 200) {
                        this.$message.success(data.msg);
                        this.searchForm.pageNumber = 1;
                        this.getHotelList();
                    }
                })
        },
        handleSearchHotel() {
            this.selectForm.pageNumber = 1;

            this.getAllHotelList();
        },
        resetForm() {
            this.selectForm.name = "";
            this.selectForm.pageNumber = 1;
            this.getAllHotelList();
        },

        handleChangeSelectPage(page) {
            this.selectForm.pageNumber = page;
            this.getAllHotelList();
        },
        handleChangePage(v) {
            this.searchForm.pageNumber = v;
            this.getHotelList();

        },
        handleChangesize(v) {
            this.searchForm.pageSize = v;
            this.searchForm.pageNumber = 1;
            this.getHotelList();
        },
        getHotelList() {
            this.getRequest(this.httpConfig.getHotel, this.searchForm).then(res => {
                let data = res.data;

                if (data.code == 200) {
                    this.hotelList = data.data.records;
                    this.total = data.data.total;
                }
            })
        },
        getAllHotelList() {
            this.getRequest(this.httpConfig.selectHotel, this.selectForm).then(res => {
                let data = res.data;
                if (data.code == 200) {
                    this.selectHotelList = data.data.records.map(item => {
                        item.hotelId = item.id;
                        return item;
                    });
                    this.hotelTotal = data.data.total;

                    this.$nextTick(() => {
                        if (this.selectHotelList.length) {
                            this.$refs.multipleTable.clearSelection();
                            this.selections.forEach(row => {
                                this.selectHotelList.forEach(item => {

                                    if (row.hotelId == item.hotelId) {
                                        this.$refs.multipleTable.toggleRowSelection(item, true);
                                    }
                                })

                            });
                        } else {
                            this.$refs.multipleTable.clearSelection();
                        };
                    })
                }
            })
        },
    },
}
</script>